import React from 'react';

import { useTranslation } from '@atlas/core';

const PARAMS_REPLACE_RX = /\[(\w+)\]/g;

export default function useTranslate() {
  const translation = useTranslation();

  return React.useCallback(
    (message, params) => {
      if (!message || !translation) {
        return '';
      }
      const messageKey = message.replace(/\s/g, '_').toLowerCase();
      const messageParams = params || {};
      const translatedMessage = translation[messageKey] || `#${messageKey}`;

      return translatedMessage.replace(PARAMS_REPLACE_RX, (value, match) => {
        if (!messageParams[match]) {
          return `[${match}]`;
        }
        return messageParams[match];
      });
    },
    [translation],
  );
}
